/* ============================================================
   Re-Coco — FAQs JS
   Handles: accordion toggle, search filter
   ============================================================ */

(function () {
  'use strict';

  // ── Accordion ────────────────────────────────────────────
  document.querySelectorAll('[data-faq-btn]').forEach((btn, i) => {
    btn.addEventListener('click', () => {
      const answer  = btn.nextElementSibling;
      const isOpen  = answer && answer.classList.contains('open');
      const iconEl  = btn.querySelector('[data-faq-icon]');

      // Close all
      document.querySelectorAll('.faq-answer').forEach(a => a.classList.remove('open'));
      document.querySelectorAll('[data-faq-icon]').forEach(ic => { ic.textContent = '+'; });

      // Open clicked (unless it was already open)
      if (!isOpen && answer) {
        answer.classList.add('open');
        if (iconEl) iconEl.textContent = '−';
      }
    });
  });

  // Open first by default
  const first = document.querySelector('.faq-answer');
  const firstBtn = document.querySelector('[data-faq-btn]');
  if (first) first.classList.add('open');
  if (firstBtn) {
    const ic = firstBtn.querySelector('[data-faq-icon]');
    if (ic) ic.textContent = '−';
  }

  // ── Search filter ─────────────────────────────────────────
  const searchInput = document.getElementById('faq-search');
  if (searchInput) {
    searchInput.addEventListener('input', () => {
      const q = searchInput.value.toLowerCase().trim();
      let anyVisible = false;
      document.querySelectorAll('[data-faq-item]').forEach(item => {
        const question = item.querySelector('[data-faq-btn]').textContent.toLowerCase();
        const match    = !q || question.includes(q);
        item.style.display = match ? '' : 'none';
        if (match) anyVisible = true;
      });

      const noResults = document.getElementById('faq-no-results');
      if (noResults) noResults.style.display = anyVisible ? 'none' : 'block';
    });
  }

})();
